export function idToDate(id?: string | null) {
  return new Date(1000 * parseInt(id ? id.substr(0, 8) : '', 16));
}
